import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";
import { PersonalRecibosViewColumnsOverrides } from "./PersonalRecibosViewColumnsOverrides";

const columns = () =>
(
    {
        c_proceso_id: new EntityColumn<string>({ name: 'c_proceso_id', type: 'char', length: 20, flags: c.PK, prompt: 'Proceso ID' }),
        c_detalle_id: new EntityColumn<string>({ name: 'c_detalle_id', type: 'char', length: 20, flags: c.PK, prompt: 'Detalle ID' }),
        vb_file: new EntityColumn<string>({ name: 'vb_file', type: 'varbinary', length: 0, flags: c.Edit, prompt: 'File' }),
        bt_firmado: new EntityColumn<boolean>({ name: 'bt_firmado', type: 'bit', flags: c.Edit, prompt: 'Firmado' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        pere_brwRecibos: {
            name: 'pere_brwRecibos', keyMappings: { c_proceso_id: 4, c_detalle_id: 5 }
            , gridColumnsOverrides: PersonalRecibosViewColumnsOverrides
        },
    }
)

const procs = () =>
(
    {
        pere_FirmarRecibo: { name: 'pere_FirmarRecibo' },
    }
)

export class PersonalRecibosDef extends EntityDefinition {

    columns = columns();
    views = views();
    procs = procs();

    constructor() {
        super('PersonalRecibos');
    }
}